import BaseObjectInterface from "./BaseObject";
import PortadorInterface from "./Portador";
import { Estoque, Produto } from "./Produto";

export default interface PedidoInterface {
    id: number;
    nroPedido: any;
    descricao: string;
    data: string;
    valorTotal: any;
    quantidade: number;
    produtos: PedidoProduto[];
    portador?: PortadorInterface;
    condicaoPgto?: BaseObjectInterface;
    dataEntrega: string;
    comprador: string;
    ordemCompra: string;
    edicao: boolean;
    situacao?: string;
    user?: any;
    observacoes?: string;
    carregado: boolean;
    trocas?: any[];
    nroNota?: string;
    cupomDesconto?: {
        id?: number;
        cupom_code?: string;
    }[];
    valorAplicadoCupom?: number;
    error_message?: {
        message: string;
        type: "CUPOM_DESCONTO";
    }[]
}

export interface PedidoProduto {
    id: number;
    produto: Produto;
    estoque: Estoque;
    valorUnit: string;
    quantidade: number;
    unidadeMedida: string;
    valorAplicadoCupom?: number;
    cupom_desconto_id?: number;
}

export const pedidoInitialState = {
    id: 0,
    nroPedido: 0,
    descricao: "",
    data: "",
    valorTotal: 0,
    quantidade: 0,
    produtos: [],
    portador: undefined,
    condicaoPgto: undefined,
    dataEntrega: "",
    comprador: "",
    ordemCompra: "",
    edicao: true,
    situacao: "EDICAO",
    user: undefined,
    observacoes: "",
    carregado: true,
}